import { css } from "@emotion/css";

import { white } from "@/modules/theme/utils/colors";
import { breakpointValues, Theme } from "@/modules/theme/utils/createTheme";

export const createAnonymousLayoutStyles = ({ spacing }: Theme) => {
  return {
    root: css({
      height: "100%",
      backgroundColor: white,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      maxWidth: breakpointValues.lg,
      margin: "0 auto",
    }),

    container: css({
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      height: "100%",
      width: "100%",
      padding: spacing([0, 1]),
      flex: 1,
    }),
  };
};
